module.exports = __webpack_public_path__ + "img/doorLogo26.fbea6c1a.png";